import {
  nullable,
  object,
  optional,
  passthrough,
  string,
  union,
} from "valibot";

export const EventDataSchema = object({
  message: string(),
  instanceName: optional(string()),
  type: optional(string()),
  detailType: optional(string()),
  detail: optional(nullable(union([string(), passthrough(object({}))]))),
});
